import { render, staticRenderFns } from "./workload.vue?vue&type=template&id=287611b4&"
import script from "./workload.vue?vue&type=script&lang=js&"
export * from "./workload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports